<template>
	<div class="index">
		<div class="chat-list">
			<div class="nav-title">私信</div>
			<spider-search @searchTransmit="searchTransmit" @searchInput="searchInput" />
			<div class="chat-list-user">
				<div v-for="(item, index) in dataList" :key="item.targetId" @click="lookChatRecords(item)"
					:class="currentTargetId == item.targetId ? 'active-background' : 'user-info'">
					<div class="user-icon">
						<img :src="item.infoData.avatar" v-if="item.infoData && item.infoData.avatar" />
						<img src="@/assets/images/logo@3x.png" v-else />
						<span v-if="item.unreadMessageCount > 0" :class="item.unreadMessageCount < 10 ? 'badge' : 'badge2'">
							{{ item.unreadMessageCount }}
						</span>
					</div>
					<div class="user-right">
						<div>
							<p class="user_name">
								{{ (item.infoData && (item.infoData.remark || item.infoData.nickName)) || item.nickName || '暂无' }}
							</p>
							<p v-if="isToday(item.endTime)">
								{{ formateDate(item.endTime,"HH:mm") }}
							</p>
							<!-- // 这里把时间戳转换为`日`，然后跟当前的`日`进行比较，如果相等，则说明是今天的时间戳，则显示`time` -->
							<p v-else-if="isYesterday(item.endTime)">昨天</p>
							<!-- // 这里把**当前**的时间戳 `-1`，说明是昨天。比如说今天是18日，`-1`之后就是17，如果`time`转换后 与 17 相等，说明应该显示为`昨天`。 -->
							<p v-else-if="isDayBeforeYesterday(item.endTime)">前天</p>
							<p v-else>{{ formateDate(item.endTime, "MM/dd") }}</p>
						</div>
						<p style="font-size: 12px; color: #7b7d80" class="msg-box">
							{{ item.latestMessageText || (item.latestMessage | messageFormatting) }}
						</p>
					</div>
				</div>
			</div>
		</div>
		<div v-if="isShow" class="default">
			<img src="@/assets/images/logo@3x.png" />
		</div>
		<!-- 聊天框 -->
		<spider-window-messagebox ref="SpiderWindowMessagebox" v-else />
	</div>
</template>

<script>
	import spiderSearch from "../../../components/spider-search/spider-search.vue";
	import SpiderWindowMessagebox from "../../../components/spider-window-message/spider-window-messagebox.vue";
	import {
		mapState
	} from "vuex";

	export default {
		components: {
			spiderSearch,
			SpiderWindowMessagebox
		},
		data() {
			return {
				dataList: [],
				current: null,
				currentTargetId: '', // 当前选中的会话 targetId（替代 index 方式，避免列表重排后高亮错位）
				isShow: true,
				chatList: [],
				total: 0,
				originalDataList: [], // 原始数据缓存
				searchTimer: null, // 搜索防抖定时器
				updateTimer: null, // 消息更新防抖定时器

				// 性能优化相关属性
				isLoading: false, // 防止重复加载
				lastUpdateTime: 0, // 最后更新时间
				updateInterval: 1000, // 最小更新间隔(毫秒)，延长间隔减少网络差时的竞态
				lastClearTime: 0, // 最后清除未读数时间
				visibleRange: { start: 0, end: 50 }, // 可视范围
				itemHeight: 67, // 每行高度(像素)
				fetchRequestId: 0, // 会话列表请求 ID，防止竞态条件
				recentlyClearedTargetId: '', // 最近刚清除未读的会话 targetId，用于保护期判断
				clearProtectTime: 3000, // 清除未读后的保护期(毫秒)，此期间接口数据不覆盖未读数
				userDetailCache: new Map(), // 用户详情缓存，避免竞态条件和重复请求
			};
		},
		computed: {
			...mapState({
				msgArr: (state) => state.rongyun.sendMsgArr,
				updateList: (state) => state.rongyun.updateList, //更新列表
				//获取到vuex融云实例化的数据
				RongIMClient: (state) => state.rongyun.RongIMClient, //融云实例
				upDateMessageNum: (state) => state.updateNum.upDateMessageNum, //私信的数量
				messageList: (state) => state.rongyun.messageList, //消息列表
				msgUpdateStatus: (state) => state.rongyun.msgUpdateStatus, //通知消息列表更新
			}),
		},
		watch: {
			msgArr(newVal, oldVal) {
				oldVal = newVal;
			},
			//监听融云实例
			RongIMClient(newVal, oldVal) {
				oldVal = newVal;
			},
			//监听消息列表
			messageList(newVal, oldVal) {
				oldVal = newVal;
			},
			//监听消息列表未读的数量
			upDateMessageNum(newVal, oldVal) {
				oldVal = newVal;
				setTimeout(() => {
					this.getMessageList();
				}, 100);
			},
			//更新聊天列表
			updateList(newVal, oldVal) {
				oldVal = newVal;
				// this.getMessageList()
				setTimeout(() => {
					this.getMessageList();
				}, 100);
			},
		},
		filters: {
			//信息类型格式化
			messageFormatting(val) {
				if (!val) return '[暂无消息]'

				// content 可能是字符串（融云某些版本），需要兼容处理
				let content = val.content
				if (typeof content === 'string') {
					try {
						content = JSON.parse(content)
					} catch(e) {
						// 解析失败，直接作为文本消息返回
						return content.length > 30 ? content.substring(0, 30) + '...' : content
					}
				}

				if(content && content.operation == 'receiveRedPack'){
					return '[不支持红包消息]'
				}

				// messageType 可能是数字（融云 SDK 内部枚举），需要兼容
				let msgType = val.messageType || ''
				// 融云 SDK v4 枚举值映射
				const typeMap = {
					1: 'RC:TxtMsg',
					2: 'RC:ImgMsg', 
					3: 'RC:SightMsg',
					4: 'RC:AudioMsg',
					5: 'RC:VideoMsg',
					6: 'RC:FileMsg',
					7: 'RC:LBSMsg',
					8: 'RC:StkImgMsg',
					10: 'RC:RcCmd',
					11: 'RC:GrpNtf',
					12: 'RC:InfoNtf',
					13: 'RC:ContactNtf',
					14: 'RC:ProfileNtf',
					15: 'RC:CmdNtf',
					16: 'RC:CmdMsg',
					17: 'RC:AckMsg',
					18: 'RC:EqMsg',
					19: 'RC:ImgTextMsg',
					20: 'RC:FileMsg', // 某些版本文件消息用20
					21: 'RC:CombineMsg',
					22: 'RC:RCMultiCmdMsg',
				}
				if (typeof msgType === 'number' && typeMap[msgType]) {
					msgType = typeMap[msgType]
				}

				switch (msgType) {
					case 'ST:GrpNtf':
						return content.message || '[群通知]'
					case 'RC:TxtMsg':
						return content.content || ''
					case 'RC:SRSMsg':
						// RC:SRSMsg 可能是系统通知（有content.content）或状态同步消息（空content）
						if (content.content) {
							const text = String(content.content)
							return text.length > 30 ? text.substring(0, 30) + '...' : text
						}
						return '[不支持此类型消息]'
					case 'RC:GiftMsg':
						return '[礼物]'
					case 'RC:ImgMsg':
						return '[图片]'
					case 'RC:StkImgMsg':
						return '[表情]'
					case 'RC:FileMsg':
						return '[文件]'
					case 'RC:ArticleMsg':
						return '[文章]'
					case 'RC:CombineMsg':
						return '[不支持转发消息]'
					case 'RC:SightMsg':
						return '[视频]'
					case 'RC:RcCmd':
						return '[不支持消息]'
					case 'RC:VcMsg':
					case 'RC:HQVCMsg':
						return '[不支持语音消息]'
					case 'RC:SCCardMsg':
						return content.is_CardType == 0 ? '[不支持名片消息]' : '[不支持卡片消息]'
					// case 'RC:GroupInviteMsg':
					// 	return '[不支持群聊邀请消息]'
					case 'RC:GroupInviteMsg':
						// if(val.messageDirection == 1){ // 发出信息
						// 	str = `你邀请${val.senderUser}参加{{ item.content.name }}`
						// }
						// } else if(val.messageDirection == 2){ // 收到的信息
						// 	str = `${val.senderUser}邀请你参加${val.content.name}`
						// }

						// 群组类型 0默认群聊 1会议 2活动 3婚礼4宴席5殡礼6庆典7生日会    integer(int32)
						let str = '[不支持群聊邀请消息]'
						if(content.type == 1){
							str = '[会议邀请]'
						} else if(content.type == 2){
							str = '[活动邀请]'
						}else if(content.type == 3){
							str = '[婚礼邀请]'
						}else if(content.type == 4){
							str = '[宴席邀请]'
						}else if(content.type == 5){
							str = '[殡礼邀请]'
						}else if(content.type == 6){
							str = '[庆典邀请]'
						}else if(content.type == 7){
							str = '[生日会邀请]'
						} else {
							str = '[群聊邀请]'
						}
						
						return str
					case 'RC:InvitationMsg':
						return '[不支持邀请函消息]'
					case 'RC:LBSMsg':
						return '[不支持位置消息]'
					case 'RC:RecordSpeechMsg':
						return '[不支持录音讲话消息]'
					case 'RC:VideoSpeechMsg':
						return '[不支持视频讲话消息]'
					case 'RC:SpiderDramaMsg':
						return '[不支持蜘影剧消息]'
					case 'RC:SpiderNewsMsg':
						return '[不支持蜘影新闻消息]'
					case 'RC:SpiderShadowMsg':
						return '[不支持蜘影消息]'
					case 'RC:CardMsg':
						return content.is_CardType == 0 ? '[不支持名片消息]' : '[不支持卡片消息]'
					case 'RC:TransferMsg':
						return '[不支持红包消息]'
					case 'redBagExpire': // 过期的红包消息
						return '[不支持红包消息]'
					case 'receiveRedPack':
						return '[不支持红包消息]'
					default:
					// 兜底：使用解析后的 content 对象判断消息类型
					if (content && content.sightUrl) {
						return '[视频]'
					}
					if (content && content.fileUrl) {
						return '[文件]'
					}
					if (content && content.imageUri) {
						return '[图片]'
					}
					// 通用兜底：遍历 content 所有字段，找到第一个有意义的文本
					if (content && typeof content === 'object') {
						// 跳过 typing indicator 标识字段，避免把 "RC:TxtMsg" 类型标识当成消息内容显示
						const skipKeys = ['typingContentType', 'isTyping', 'typing', 'typingStatus', 'typingMessageType'];
						const textFields = ['message', 'content', 'data', 'notification', 'text', 'extra', 'info', 'notice', 'remark', 'description', 'title']
						for (const field of textFields) {
							if (content[field] && typeof content[field] === 'string' && content[field].trim()) {
								const text = content[field]
								return text.length > 30 ? text.substring(0, 30) + '...' : text
							}
						}
						// 最终兜底：遍历所有 string 类型字段，跳过 typing 标识字段
						for (const key in content) {
							if (skipKeys.includes(key)) continue;
							if (typeof content[key] === 'string' && content[key].length > 2) {
								const text = content[key]
								return text.length > 30 ? text.substring(0, 30) + '...' : text
							}
						}
					}
					console.log('未识别的消息类型:', val.messageType, val)
					return '[不支持此类型消息]'
				}
			},
			//日期格式化
			formatDate(date, fmt) {
				date = new Date(date);
				if (typeof fmt === "undefined") {
					fmt = "yyyy-MM-dd HH:mm:ss";
				}
				if (/(y+)/.test(fmt)) {
					fmt = fmt.replace(
						RegExp.$1,
						(date.getFullYear() + "").substr(4 - RegExp.$1.length)
					);
				}
				let o = {
					Y: date.getFullYear(),
					"M+": date.getMonth() + 1,
					"d+": date.getDate(),
					"H+": date.getHours(),
					"m+": date.getMinutes(),
					"s+": date.getSeconds(),
				};
				for (let k in o) {
					if (new RegExp(`(${k})`).test(fmt)) {
						let str = o[k] + "";
						fmt = fmt.replace(
							RegExp.$1,
							RegExp.$1.length === 1 ? str : ("00" + str).substr(str.length)
						);
					}
				}
				return fmt;
			},
			// 日期格式化（兼容模板中的拼写）
			formateDate(date, fmt) {
				// 确保 date 是有效的日期对象
				let dateObj;
				if (date instanceof Date) {
					dateObj = date;
				} else if (typeof date === 'string') {
					// 处理 Safari 浏览器的日期解析问题
					try {
						// 尝试标准解析
						dateObj = new Date(date);
						// 如果解析失败，尝试使用更兼容的格式
						if (isNaN(dateObj.getTime())) {
							// 尝试将 "yyyy-MM-dd HH:mm:ss" 格式转换为 "yyyy/MM/dd HH:mm:ss"
							const compatibleDateStr = date.replace(/-/g, '/');
							dateObj = new Date(compatibleDateStr);
						}
					} catch (e) {
						dateObj = new Date();
					}
				} else {
					dateObj = new Date();
				}
				
				if (typeof fmt === "undefined") {
					fmt = "yyyy-MM-dd HH:mm:ss";
				}
				if (/(y+)/.test(fmt)) {
					fmt = fmt.replace(
						RegExp.$1,
						(dateObj.getFullYear() + "").substr(4 - RegExp.$1.length)
					);
				}
				let o = {
					Y: dateObj.getFullYear(),
					"M+": dateObj.getMonth() + 1,
					"d+": dateObj.getDate(),
					"H+": dateObj.getHours(),
					"m+": dateObj.getMinutes(),
					"s+": dateObj.getSeconds(),
				};
				for (let k in o) {
					if (new RegExp(`(${k})`).test(fmt)) {
						let str = o[k] + "";
						fmt = fmt.replace(
							RegExp.$1,
							RegExp.$1.length === 1 ? str : ("00" + str).substr(str.length)
						);
					}
				}
				return fmt;
			},
		},
		created() {
			setTimeout(() => {
				// 先恢复 targetId，避免 getMessageList 执行期间 targetId 为空导致红点闪现
				if (localStorage.getItem("chatRecords")) {
					const chatRecords = JSON.parse(localStorage.getItem("chatRecords"));
					this.$store.commit('setTargetId', chatRecords.targetId);
				}
				this.getMessageList(); //获取消息列表
				// this.getNoReadNum() //获取全部会话未读数 私聊的
				// this.$store.dispatch('getMessageList',this)
				if (localStorage.getItem("chatRecords")) {
					this.lookChatRecords(JSON.parse(localStorage.getItem("chatRecords")));
				}
			}, 1000);
		},
		mounted() {
			// 监听来自 slider-bar 的消息事件
			this.$root.$on('new-private-message', this.handlePrivateMessage);
			this.$root.$on('group-message-in-chat', this.handleGroupMessageInChat);
			// 监听本地发送的消息事件，刷新私信列表
			this.$root.$on('private-message-sent', this.handlePrivateMessageSent);
		},
		beforeDestroy() {
			// 移除事件监听器
			this.$root.$off('new-private-message', this.handlePrivateMessage);
			this.$root.$off('group-message-in-chat', this.handleGroupMessageInChat);
			this.$root.$off('private-message-sent', this.handlePrivateMessageSent);
		},
		methods: {
			sameTargetId(a, b) {
				return a != null && b != null && String(a) === String(b);
			},
			getOpenChatTargetId() {
				// 只有聊天窗口真正打开时，才视为“正在聊天”
				if (this.isShow) return '';
				return this.$store.state.rongyun.targetId || '';
			},
			persistConversationList() {
				this.originalDataList = [...this.dataList];
				localStorage.setItem('conversationList', JSON.stringify(this.dataList));
				localStorage.setItem('conversationListCacheTime', Date.now().toString());
			},
			// 将指定私聊标为已读（融云侧），避免窗口打开期间消息仍累计未读
			markConversationRead(targetId) {
				if (!this.RongIMClient || !targetId) return Promise.resolve();
				try {
					const conversation = this.RongIMClient.Conversation.get({
						targetId: targetId,
						type: window.RongIMLib.CONVERSATION_TYPE.PRIVATE,
					});
					if (!conversation || typeof conversation.read !== 'function') {
						return Promise.resolve();
					}
					return conversation.read().catch((error) => {
						console.error('markConversationRead: 标记已读失败', error);
					});
				} catch (e) {
					console.error('markConversationRead: 异常', e);
					return Promise.resolve();
				}
			},
			// 处理来自 slider-bar 的私信消息
			handlePrivateMessage(message) {
				console.log("privateLetter: 收到私信消息", message);

				// 过滤融云"正在输入"(typing indicator) 状态消息
				// 这类消息 messageType 是 RC:TxtMsg 但 content.content 为空，不是真实消息
				if (this.isTypingIndicator(message)) {
					console.log('privateLetter: 跳过 typing indicator 状态消息');
					return;
				}

				// 跳过 RC:SRSMsg 状态同步消息（空内容），避免覆盖正确的消息预览和时间
				if (message.messageType === 'RC:SRSMsg') {
					let content = message.content;
					if (typeof content === 'string') {
						try { content = JSON.parse(content); } catch(e) { content = {}; }
					}
					if (!content || !content.content) {
						console.log('privateLetter: 跳过空的 RC:SRSMsg 状态同步消息');
						return;
					}
				}
				
				const currentChatTargetId = this.getOpenChatTargetId();
				const currentUserId = this.loginMsg?.memberId || JSON.parse(localStorage.getItem('loginMsg')).memberId;
				
				let isCurrentChat = false;
				if (message.type === 1) { // 1表示私信
					// 判断是否是当前正在聊天的会话
					// 如果是自己发送的消息，检查targetId是否是当前聊天对象
					// 如果是收到的消息，检查senderUserId是否是当前聊天对象
					if (String(message.senderUserId) === String(currentUserId)) {
						// 自己发送的消息，检查接收者是否是当前聊天对象
						isCurrentChat = this.sameTargetId(message.targetId, currentChatTargetId);
					} else {
						// 收到的消息，检查发送者是否是当前聊天对象
						isCurrentChat = this.sameTargetId(message.senderUserId, currentChatTargetId);
					}
				} else {
					isCurrentChat = this.sameTargetId(message.targetId, currentChatTargetId);
				}

				if (isCurrentChat) {
					console.log('正在与发送消息的用户聊天，更新聊天窗口显示并立即已读');
					this.$nextTick(() => {
						this.updateCurrentSessionDisplay(message);
					});
					// 窗口打开期间收到的消息必须立刻标已读，否则切走后再来消息会把这段也算进去
					this.markConversationRead(currentChatTargetId);
					const currentIndex = this.dataList.findIndex(item => this.sameTargetId(item.targetId, currentChatTargetId));
					if (currentIndex !== -1 && this.dataList[currentIndex].unreadMessageCount) {
						this.$set(this.dataList, currentIndex, {
							...this.dataList[currentIndex],
							unreadMessageCount: 0,
						});
						this.persistConversationList();
					}
					this.computedListNoRead();
					return;
				}

				// 非当前聊天：立即本地更新未读数和最新消息，避免等接口返回导致红点位置错乱
				const msgTargetId = (message.type === 1 && String(message.senderUserId) === String(currentUserId))
					? message.targetId  // 自己发的消息，对方是 target
					: message.senderUserId;  // 收到的消息，发送者是 target
				
				const sessionIndex = this.dataList.findIndex(item => this.sameTargetId(item.targetId, msgTargetId));
				const isNewSession = sessionIndex === -1;
				
				if (!isNewSession) {
					const session = this.dataList[sessionIndex];
					const newSentTime = message.sentTime || Date.now();
					const oldSentTime = session.latestMessage?.sentTime || 0;

					// 只有新消息时间更新时才更新 latestMessage 和时间
					if (newSentTime >= oldSentTime) {
						session.latestMessage = message;
						session.latestMessageText = this.$options.filters.messageFormatting(message);
						session.endTime = this.formattingTime(newSentTime);
					}

					// 触发响应式更新
					this.$set(this.dataList, sessionIndex, { ...session });

					// 重新排序
					this.dataList.sort((a, b) =>
						new Date(b.latestMessage?.sentTime || 0) - new Date(a.latestMessage?.sentTime || 0)
					);
					this.dataList = [...this.dataList];
					this.persistConversationList();

					// 不本地递增未读数，改为立即从融云获取该会话真实未读数（像微信一样信任服务端）
					this.syncUnreadFromRongCloud(msgTargetId);
				} else {
					// 新会话：先插入本地未读，保证列表红点和侧栏「私信」角标同时出现
					console.log('handlePrivateMessage: 新会话，先本地插入再同步列表');
					this.insertNewSessionFromMessage(message, msgTargetId);
				}
			},
			insertNewSessionFromMessage(message, msgTargetId) {
				const cachedDetail = this.userDetailCache.get(msgTargetId) || this.userDetailCache.get(String(msgTargetId));
				const newSentTime = message.sentTime || Date.now();
				const currentUserId = this.loginMsg?.memberId || JSON.parse(localStorage.getItem('loginMsg')).memberId;
				const isOwnMessage = String(message.senderUserId) === String(currentUserId);
				const newSession = {
					targetId: msgTargetId,
					conversationType: 1,
					latestMessage: message,
					latestMessageText: this.$options.filters.messageFormatting(message),
					endTime: this.formattingTime(newSentTime),
					unreadMessageCount: isOwnMessage ? 0 : 1,
					infoData: cachedDetail || null,
					nickName: cachedDetail
						? (cachedDetail.remark || cachedDetail.nickName || msgTargetId)
						: msgTargetId,
				};
				this.dataList = [newSession, ...this.dataList.filter(item => !this.sameTargetId(item.targetId, msgTargetId))];
				this.persistConversationList();
				this.computedListNoRead();
				if (!cachedDetail) {
					this.fetchUserDetailAsync(msgTargetId);
				}
				this.getMessageList(true);
			},
			// 从融云获取指定会话的真实未读数并更新本地列表（像微信一样信任服务端）
			// 判断是否是融云"正在输入"(typing indicator) 状态消息
			isTypingIndicator(message) {
				if (!message) return false;
				let content = message.content;
				if (typeof content === 'string') {
					try { content = JSON.parse(content); } catch(e) { content = {}; }
				}
				const typingKeys = ['typingContentType', 'isTyping', 'typing', 'typingStatus', 'typingMessageType'];
				if (content && typeof content === 'object') {
					for (const key of typingKeys) {
						if (key in content) return true;
					}
				}
				const msgType = message.messageType;
				const typeMap = { 1: 'RC:TxtMsg' };
				const strType = typeMap[msgType] || msgType;
				if (strType === 'RC:TxtMsg' && (!content || !content.content || String(content.content).trim() === '')) {
					return true;
				}
				return false;
			},
			// 从融云获取指定会话的真实未读数并更新本地列表（像微信一样信任服务端）
			// 策略：先本地+1即时显示红点，延迟后用融云真实值覆盖；
			// 若融云返回0但本地刚+1（SDK 计数延迟），保留本地值不清零
			syncUnreadFromRongCloud(targetId) {
				const idx = this.dataList.findIndex(item => this.sameTargetId(item.targetId, targetId));
				if (idx === -1) {
					this.computedListNoRead();
					return;
				}
				// 当前正在聊天的会话：未读数强制为0，不+1
				const currentChatTargetId = this.getOpenChatTargetId();
				if (this.sameTargetId(targetId, currentChatTargetId)) {
					const session = this.dataList[idx];
					session.unreadMessageCount = 0;
					this.$set(this.dataList, idx, { ...session });
					this.persistConversationList();
					this.computedListNoRead();
					this.markConversationRead(targetId);
					return;
				}
				// 非当前聊天：本地+1即时显示红点（像微信一样收消息立即有红点）
				const session = this.dataList[idx];
				const localCount = (session.unreadMessageCount || 0) + 1;
				session.unreadMessageCount = localCount;
				this.$set(this.dataList, idx, { ...session });
				this.persistConversationList();
				this.computedListNoRead();

				// 延迟从融云获取真实未读数覆盖（融云 SDK 计数有延迟，立即获取可能返回0）
				if (!this.RongIMClient) return;
				try {
					const conversation = this.RongIMClient.Conversation.get({
						targetId: targetId,
						type: window.RongIMLib.CONVERSATION_TYPE.PRIVATE,
					});
					if (!conversation || typeof conversation.getUnreadCount !== 'function') return;
					setTimeout(() => {
						conversation.getUnreadCount().then((count) => {
							const curIdx = this.dataList.findIndex(item => this.sameTargetId(item.targetId, targetId));
							if (curIdx === -1) return;
							if (this.sameTargetId(targetId, this.getOpenChatTargetId())) {
								this.dataList[curIdx].unreadMessageCount = 0;
								this.$set(this.dataList, curIdx, { ...this.dataList[curIdx] });
								this.persistConversationList();
								this.computedListNoRead();
								return;
							}
							const curSession = this.dataList[curIdx];
							const rongCount = count || 0;
							// 融云返回0但本地刚+1：SDK 计数延迟，保留本地值不清零
							// 融云返回>0：信任融云真实值
							let finalCount;
							if (rongCount === 0 && localCount > 0) {
								finalCount = localCount;
							} else {
								finalCount = rongCount;
							}
							curSession.unreadMessageCount = finalCount;
							this.$set(this.dataList, curIdx, { ...curSession });
							this.persistConversationList();
							this.computedListNoRead();
							console.log('syncUnreadFromRongCloud: targetId:', targetId, '本地:', localCount, '融云:', rongCount, '最终:', finalCount);
						}).catch(err => {
							console.error('syncUnreadFromRongCloud: 获取未读数失败', err);
						});
					}, 500);
				} catch (e) {
					console.error('syncUnreadFromRongCloud: 异常', e);
				}
			},
			// 处理本地发送的消息，刷新私信列表
			handlePrivateMessageSent(message) {
				console.log('privateLetter: 本地发送消息，刷新列表', message);
				// 延迟刷新，确保融云本地状态已更新（使用force模式跳过频率控制和缓存）
				setTimeout(() => {
					this.getMessageList(true);
				}, 800);
			},
			
			// 处理来自 slider-bar 的群组消息（在当前聊天中）
			handleGroupMessageInChat(message) {
				console.log("privateLetter: 收到群组消息（在当前聊天中）", message);
				this.$nextTick(() => {
					this.updateCurrentSessionDisplay(message);
				});
			},
			
			//日期格式化
			formateDate(date, fmt) {
				// 确保 date 是有效的日期对象
				let dateObj;
				if (date instanceof Date) {
					dateObj = date;
				} else if (typeof date === 'string') {
					// 处理 Safari 浏览器的日期解析问题
					try {
						// 尝试标准解析
						dateObj = new Date(date);
						// 如果解析失败，尝试使用更兼容的格式
						if (isNaN(dateObj.getTime())) {
							// 尝试将 "yyyy-MM-dd HH:mm:ss" 格式转换为 "yyyy/MM/dd HH:mm:ss"
							const compatibleDateStr = date.replace(/-/g, '/');
							dateObj = new Date(compatibleDateStr);
						}
					} catch (e) {
						dateObj = new Date();
					}
				} else {
					dateObj = new Date();
				}
				
				if (typeof fmt === "undefined") {
					fmt = "yyyy-MM-dd HH:mm:ss";
				}
				if (/(y+)/.test(fmt)) {
					fmt = fmt.replace(
						RegExp.$1,
						(dateObj.getFullYear() + "").substr(4 - RegExp.$1.length)
					);
				}
				let o = {
					Y: dateObj.getFullYear(),
					"M+": dateObj.getMonth() + 1,
					"d+": dateObj.getDate(),
					"H+": dateObj.getHours(),
					"m+": dateObj.getMinutes(),
					"s+": dateObj.getSeconds(),
				};
				for (let k in o) {
					if (new RegExp(`(${k})`).test(fmt)) {
						let str = o[k] + "";
						fmt = fmt.replace(
							RegExp.$1,
							RegExp.$1.length === 1 ? str : ("00" + str).substr(str.length)
						);
					}
				}
				return fmt;
			},
			//搜索框的搜索
			searchTransmit(val) {
				if (!val || val.trim() === '') {
					// 如果搜索词为空，恢复原始数据
					this.dataList = [...this.originalDataList];
					return;
				}
				const searchTerm = val.toLowerCase().trim();
				let arr = [];
				
				// 确保使用原始数据进行搜索
				if (this.originalDataList.length === 0) {
					console.warn('原始数据为空，无法进行搜索');
					return;
				}

				this.originalDataList.forEach((item) => {
					if (!item || !item.infoData) return;
					
					try {
						const nickname = (item.infoData.nickName || '').toLowerCase();
						const remark = (item.infoData.remark || '').toLowerCase();
						const displayName = (item.nickName || '').toLowerCase();
						const latestMessage = item.latestMessage ? 
							(item.latestMessage.content && item.latestMessage.content.content ? 
								item.latestMessage.content.content.toLowerCase() : '') : '';
						
						if (nickname.includes(searchTerm) || 
							remark.includes(searchTerm) || 
							displayName.includes(searchTerm) || 
							latestMessage.includes(searchTerm)) {
							arr.push(item);
						}
					} catch (error) {
						console.error('搜索处理项时出错:', error, item);
					}
				});
				
				this.dataList = [...arr];
			},
			//搜索框搜索
			searchInput(e) {

				// 清除之前的定时器
				if (this.searchTimer) {
					clearTimeout(this.searchTimer);
				}
				
				if (!e || e.trim() === '') {
					// 如果输入为空，立即恢复原始数据
					this.dataList = [...this.originalDataList];
					return;
				}
				
				// 设置防抖定时器，300ms后执行搜索
				this.searchTimer = setTimeout(() => {
					this.searchTransmit(e);
				}, 300);
			},
			//获取消息列表
			getMessageList(force) {
				// 频率控制：防止频繁调用（force模式跳过频率控制）
				if (!force) {
					const now = Date.now();
					if (this.lastUpdateTime && (now - this.lastUpdateTime) < this.updateInterval) {
						console.log('更新频率过快，跳过本次调用');
						return;
					}
					this.lastUpdateTime = now;
				}
				
				// 如果有有效的本地缓存，先显示缓存数据（快速显示）（force模式跳过缓存）
				if (!force) {
					const cache = localStorage.getItem('conversationList');
					const cacheTime = localStorage.getItem('conversationListCacheTime');
					
					// 缓存有效期：5分钟
					if (cache && cacheTime && (Date.now() - parseInt(cacheTime)) < 5 * 60 * 1000) {
						try {
							const cachedData = JSON.parse(cache);
							this.dataList = [...cachedData];
							this.originalDataList = [...cachedData];
							console.log('使用缓存数据，快速显示');
						} catch (e) {
							console.error('缓存数据解析失败:', e);
						}
					}
				}
				
				// 异步获取最新数据（后台静默更新）
				this.asyncFetchConversationList();
			},
			// 新增：异步获取会话列表（后台静默更新）
			asyncFetchConversationList() {
				// 递增请求 ID，防止竞态条件（旧响应覆盖新数据）
				const requestId = ++this.fetchRequestId;
				
				setTimeout(() => {
					const startTime = 0;
					const count = 200; // 减少一次性加载数量
					
					this.RongIMClient.Tag.get('0').then(tag => {
						tag.getConversationList(startTime, count).then(result => {
							// 如果请求已过期（有更新的请求发出），丢弃本次响应
							if (requestId !== this.fetchRequestId) {
								console.log('asyncFetchConversationList: 丢弃过期响应，requestId:', requestId, '当前:', this.fetchRequestId);
								return;
							}
							if (!result.code) {
								this.handleConversationList(result);
								// 更新缓存时间
								localStorage.setItem('conversationListCacheTime', Date.now().toString());
							}
						});
					});
				}, 100); // 稍微延迟执行，避免阻塞初始渲染
			},
			// 重写 handleConversationList 方法 - 本地未读数优先，接口数据只补充信息
			async handleConversationList(conversationList) {
				if (!conversationList || conversationList.length === 0) return;
				
				console.log('开始处理会话列表，原始数量:', this.dataList.length, '新数据数量:', conversationList.length);

				const currentChatTargetId = this.getOpenChatTargetId();
				const now = Date.now();
				
				// 创建targetId到现有会话的映射，提高查找效率
				const existingMap = new Map();
				this.dataList.forEach(item => {
					existingMap.set(String(item.targetId), item);
				});
				
				// 直接构建更新后的列表，不需要等待 API
				const newDataList = [];
				const processedIds = new Set();

				for (const item of conversationList) {
					if (item.conversationType !== 1) continue;

					const existing = existingMap.get(String(item.targetId));
					const sdkUnread = item.unreadMessageCount || 0;
					const localUnread = existing ? (existing.unreadMessageCount || 0) : 0;
					const inClearProtect = this.sameTargetId(item.targetId, this.recentlyClearedTargetId)
						&& this.lastClearTime
						&& (now - this.lastClearTime) < this.clearProtectTime;

					// 未读数：当前窗口=0；刚点开的保护期保持已读；SDK 延迟时保留本地>0
					let finalUnreadCount;
					if (this.sameTargetId(item.targetId, currentChatTargetId)) {
						finalUnreadCount = 0;
					} else if (inClearProtect && localUnread === 0) {
						finalUnreadCount = 0;
					} else if (sdkUnread === 0 && localUnread > 0) {
						finalUnreadCount = localUnread;
					} else {
						finalUnreadCount = sdkUnread;
					}

					// 预计算最新消息文本摘要，用于缓存恢复
					const latestMessageText = this.$options.filters.messageFormatting(item.latestMessage);

					if (existing) {
						// 现有会话：复用用户数据和本地未读数，只更新消息内容/时间
						// 优先用缓存中的用户详情（避免竞态条件导致 infoData 丢失）
						const cachedDetail = this.userDetailCache.get(item.targetId);
						newDataList.push({
							...item,
							infoData: cachedDetail || existing.infoData,
							nickName: cachedDetail
								? (cachedDetail.remark || cachedDetail.nickName || item.targetId)
								: existing.nickName,
							unreadMessageCount: finalUnreadCount,
							endTime: this.formattingTime(item.latestMessage?.sentTime || Date.now()),
							latestMessageText: latestMessageText,
						});
					} else {
						// 新会话：检查缓存，有则直接用，没有则用 targetId 临时显示
						const cachedDetail = this.userDetailCache.get(item.targetId);
						newDataList.push({
							...item,
							infoData: cachedDetail || null,
							nickName: cachedDetail
								? (cachedDetail.remark || cachedDetail.nickName || item.targetId)
								: item.targetId,
							unreadMessageCount: finalUnreadCount,
							endTime: this.formattingTime(item.latestMessage?.sentTime || Date.now()),
							latestMessageText: latestMessageText,
						});

						// 无缓存时后台异步获取用户详情
						if (!cachedDetail) {
							this.fetchUserDetailAsync(item.targetId);
						}
					}
					processedIds.add(item.targetId);
				}
				
				// 按最后消息时间排序
				newDataList.sort((a, b) => 
					new Date(b.latestMessage?.sentTime || 0) - new Date(a.latestMessage?.sentTime || 0)
				);
				
				// 更新数据
				this.dataList = newDataList;
				this.originalDataList = [...newDataList];
				
				// 更新缓存（缓存中也保留本地未读数，避免刷新后错乱）
				localStorage.setItem('conversationList', JSON.stringify(newDataList));
				localStorage.setItem('conversationListCacheTime', Date.now().toString());
				
				// 更新未读数
				this.computedListNoRead();
				
				console.log('会话列表更新完成，新数量:', newDataList.length, '(本地未读数优先模式)');
			},
			
			// 后台异步获取用户详情并更新会话列表（带重试和缓存）
			fetchUserDetailAsync(targetId, retryCount = 0) {
				// 已有缓存则直接使用
				if (this.userDetailCache.has(targetId)) {
					this.applyUserDetail(targetId, this.userDetailCache.get(targetId));
					return;
				}

				setTimeout(() => {
					this.$api.userMsg.userDetail(targetId).then(res => {
						if (res.result) {
							this.userDetailCache.set(targetId, res.result);
							this.applyUserDetail(targetId, res.result);
						}
					}).catch(err => {
						console.log(`获取用户详情失败(targetId=${targetId}, retry=${retryCount}):`, err?.message || err);
						if (retryCount < 2) {
							setTimeout(() => {
								this.fetchUserDetailAsync(targetId, retryCount + 1);
							}, (retryCount + 1) * 2000);
						}
					});
				}, 100 + retryCount * 300);
			},
			// 将用户详情应用到列表（触发响应式更新）
			applyUserDetail(targetId, detail) {
				const index = this.dataList.findIndex(item => this.sameTargetId(item.targetId, targetId));
				if (index !== -1) {
					const updated = {
						...this.dataList[index],
						nickName: detail.remark || detail.nickName || targetId,
						infoData: detail,
					};
					this.$set(this.dataList, index, updated);
					this.originalDataList = [...this.dataList];
					localStorage.setItem('conversationList', JSON.stringify(this.dataList));
				}
			},
			
			formatDate2(date, vm) {
				//当前时间格式化处理
				let str = "";
				if (new Date(date).getDate() === new Date().getDate()) {
					let date = new Date(date);
					let hour = date.getHours();
					let minute = date.getMinutes();
					hour = hour > 9 ? hour : "0" + hour;
					minute = minute > 9 ? minute : "0" + minute;
					
					str = hour + ":" + minute;
				} else if (new Date(date).getDate() === new Date().getDate() - 1) {
					str = "昨天";
				} else if (new Date(date).getDate() === new Date().getDate() + 1) {
					str = "(明日)";
				}
				if (new Date(date).getDate() < new Date().getDate() - 1) {
					let date = new Date(date);
					let month = date.getMonth() + 1;
					let day = date.getDate();
					month = month > 9 ? month : "0" + month; 
					day = day > 9 ? day : "0" + day;
					str = day + "/" + month;
				}
				return str;
			},
			//计算未读数
			computedNoRead(count) {
				this.total += count;
				this.$store.dispatch("changeMSg", {
					num: this.total,
					path: "私信",
				});
			},
			computedListNoRead() {
				const currentChatTargetId = this.getOpenChatTargetId();

				const newTotal = this.dataList.reduce((total, item) => {
					if (this.sameTargetId(item.targetId, currentChatTargetId)) {
						return total + 0;
					}
					return total + (item.unreadMessageCount || 0);
				}, 0);

				const oldTotal = this.total;
				const storeTotal = this.$store.state.updateNum.upDateMessageNum;
				this.total = newTotal;

				// 和本地累计值或侧栏 vuex 任一不一致时都要同步，避免两套计数脱节
				if (this.total !== oldTotal || this.total !== storeTotal) {
					this.$store.dispatch("changeMSg", {
						num: this.total,
						path: "私信",
					});
				}
			},
			//获取会话未读数 全部的会话未读
			getNoReadNum() {
				const conversationTypes = [window.RongIMLib.CONVERSATION_TYPE.PRIVATE];
				this.RongIMClient.Conversation.getTotalUnreadCount(
					false,
					conversationTypes
				).then((totalUnreadCount) => {
					// console.log("获取未读总数成功,组件里的", totalUnreadCount);
				});
			},
			//格式化时间
			formattingTime(time) {
				let date = new Date(time);
				let year = date.getFullYear();
				let month = date.getMonth() + 1;
				let day = date.getDate();
				let hour = date.getHours();
				let minute = date.getMinutes();
				let second = date.getSeconds();
				month = month > 9 ? month : "0" + month;
				day = day > 9 ? day : "0" + day;
				hour = hour > 9 ? hour : "0" + hour;
				minute = minute > 9 ? minute : "0" + minute;
				second = second > 9 ? second : "0" + second;
				return (
					year +
					"-" +
					month +
					"-" +
					day +
					" " +
					hour +
					":" +
					minute +
					":" +
					second
				);
			},
			//清除指定用户的未读数 聊天记录点击这个用户 就应该清除未读
			clearTargetNoReadNum(val) {
				// 清除未读数
				let conversation = this.RongIMClient.Conversation.get({
					targetId: val.targetId,
					type: window.RongIMLib.CONVERSATION_TYPE.PRIVATE,
				});
				conversation.read().then(() => {
					val.unreadMessageCount = 0;
					this.computedListNoRead();
					// 发送同步消息
					conversation.send({
						messageType: "RC:SRSMsg",
						content: {
							//从消息里获取服务器端时间，以最近一条已读 message 为准
							// lastMessageSendTime: message.sentTime,
						},
					}).then((message) => {
						// console.log("发送同步消息成功", message);
					});
				});
			},
			// 查看对应用户聊天记录
			lookChatRecords(val) {
				// 兼容 infoData 为 null 的情况（如蜘信支付等系统账号非好友）
				val.nickName = (val.infoData && (val.infoData.remark || val.infoData.nickName)) || val.nickName || val.targetId;
				val.memberId = val.targetId;
				val.avatar = val.infoData ? val.infoData.avatar : '';
				val.from = "person";

				// 如果 infoData 为空，尝试从缓存或 API 获取用户详情
				if (!val.infoData && val.targetId) {
					const cached = this.userDetailCache.get(val.targetId);
					if (cached) {
						val.infoData = cached;
						val.nickName = cached.remark || cached.nickName || val.targetId;
						val.avatar = cached.avatar || '';
					} else {
						// 缓存也没有，立即发起 API 请求获取用户详情
						this.$api.userMsg.userDetail(val.targetId).then(res => {
							if (res.result) {
								this.userDetailCache.set(val.targetId, res.result);
								// 更新列表
								this.applyUserDetail(val.targetId, res.result);
								// 更新聊天窗口
								if (this.$refs.SpiderWindowMessagebox) {
									const updatedVal = {
										...val,
										infoData: res.result,
										nickName: res.result.remark || res.result.nickName || val.targetId,
										avatar: res.result.avatar || '',
									};
									this.$refs.SpiderWindowMessagebox.init(updatedVal);
								}
							}
						}).catch(err => {
							console.log('lookChatRecords: 获取用户详情失败:', val.targetId, err?.message || err);
						});
					}
				}

				localStorage.setItem("chatRecords", JSON.stringify(val));

				this.isShow = false;

				const previousTargetId = this.$store.state.rongyun.targetId;
				// 切走前把上一会话窗口期间收到的消息标为已读
				if (previousTargetId && !this.sameTargetId(previousTargetId, val.targetId)) {
					this.markConversationRead(previousTargetId);
				}

				// 设置当前选中的会话 targetId，用于高亮显示（列表重排后也不会错位）
				this.currentTargetId = val.targetId;

				// 设置当前聊天目标ID，用于后续判断是否需要显示红点
				this.$store.commit('setTargetId', val.targetId);

				// 立即本地更新，不等待服务器响应
				this.lastClearTime = Date.now();
				this.recentlyClearedTargetId = val.targetId; // 设置清除保护，防止延迟返回的接口数据恢复未读数

				// 立即更新本地列表中的该会话未读数
				val.unreadMessageCount = 0;

				const index = this.dataList.findIndex(item => this.sameTargetId(item.targetId, val.targetId));
				if (index !== -1) {
					this.dataList[index] = { ...this.dataList[index], unreadMessageCount: 0 };
					this.dataList = [...this.dataList]; // 触发响应式更新
					this.persistConversationList();
				}

				// 侧栏未读以本地列表为准，避免融云延迟重算把角标加回来
				this.computedListNoRead();

				// 延迟执行，确保DOM更新
				this.$nextTick(() => {
					if (this.$refs.SpiderWindowMessagebox) {
						this.$refs.SpiderWindowMessagebox.init(val);
					} else {
						setTimeout(() => {
							this.$nextTick(() => {
								if (this.$refs.SpiderWindowMessagebox) {
									this.$refs.SpiderWindowMessagebox.init(val);
								}
							});
						}, 600);
					}
				});
				
				// 异步清除服务器端未读数
				this.clearTargetNoReadNum(val);

				// // 异步处理服务器端操作，不阻塞界面
				// this.asyncUpdateConversationUnread(val);
				
				// // 立即打开聊天窗口，不等待任何异步操作
				// this.openChatWindow(val);
			},
			// 在 methods 中添加一个不防抖的更新方法
			updateMessageListImmediately() {
				// 立即更新消息列表，不使用防抖
				this.getMessageList();
			},
			//异步更新会话未读数（不阻塞界面）
			asyncUpdateConversationUnread(val) {
				// 使用setTimeout让其在下一轮事件循环执行，不阻塞当前操作
				setTimeout(() => {
					this.updateConversationUnreadCount(val).catch(error => {
						console.error('异步更新会话未读数失败:', error);
					});
				}, 0);
			},

			//专门处理打开聊天窗口
			openChatWindow(val) {
				if (this.$refs.SpiderWindowMessagebox) {
					this.$nextTick(() => {
						this.$refs.SpiderWindowMessagebox.init(val);
					});
				} else {
					setTimeout(() => {
						this.$nextTick(() => {
							if (this.$refs.SpiderWindowMessagebox) {
								this.$refs.SpiderWindowMessagebox.init(val);
							}
						});
					}, 600);
				}
			},


			// 更新会话未读数
			updateConversationUnreadCount(val) {
				// 获取会话对象
				let conversation = this.RongIMClient.Conversation.get({
					targetId: val.targetId,
					type: window.RongIMLib.CONVERSATION_TYPE.PRIVATE,
				});
				// 标记会话为已读
				return conversation.read().then(() => {
					// 更新未读数
					// val.unreadMessageCount = 0;
					// // 更新全局未读数
					// return this.$store.dispatch("changeMsgNum", this);
					// // 发送同步消息
				}).then(() => {
					// 只更新本地列表中的该会话未读数
					const index = this.dataList.findIndex(item => item.targetId === val.targetId);
					if (index !== -1) {
						// this.dataList[index].unreadMessageCount = 0;
						this.$set(this.dataList[index], 'unreadMessageCount', 0);
						this.dataList = [...this.dataList];
					}

					// 发送同步消息
					return conversation.send({
						messageType: "RC:SRSMsg",
						content: {
							// 可以在这里添加需要同步的数据
						},
					}).then((message) => {
						// console.log("发送同步消息成功", message);
					 	console.log('会话未读数异步更新完成');
					}).catch(error => {
						console.error('更新会话未读数失败:', error);
					});
				});
			},

			// 更新当前会话的显示而不重新获取整个列表
			updateCurrentSessionDisplay(message) {
				// 获取当前用户ID
				const currentUserId = this.loginMsg?.memberId || JSON.parse(localStorage.getItem('loginMsg')).memberId;
				// 判断消息方向：1表示发送的消息，2表示接收的消息
				const messageDirection = message.senderUserId.toString() === currentUserId.toString() ? 1 : 2;
				
				// 找到当前会话并更新其最新消息显示
				const currentIndex = this.dataList.findIndex(item => this.sameTargetId(item.targetId, this.$store.state.rongyun.targetId));
				if (currentIndex !== -1) {
					const currentSession = this.dataList[currentIndex];
					// 重新计算最新消息文本摘要
					let latestMessageText = this.$options.filters.messageFormatting(message);
					// 如果新算出的文本是"不支持此类型消息"，保留原有的文本，避免覆盖正确的预览
					if (latestMessageText === '[不支持此类型消息]' && currentSession.latestMessageText) {
						latestMessageText = currentSession.latestMessageText;
					}
					// 只有新消息时间 >= 旧消息时间时，才更新 endTime 和 latestMessage
					const newSentTime = message.sentTime || Date.now();
					const oldSentTime = currentSession.latestMessage?.sentTime || 0;
					const shouldUpdateTime = newSentTime >= oldSentTime;
					// 更新最新消息内容和时间
					const updatedSession = {
						...currentSession,
						latestMessage: shouldUpdateTime ? message : currentSession.latestMessage,
						latestMessageText: latestMessageText,
						endTime: shouldUpdateTime ? this.formattingTime(newSentTime) : currentSession.endTime,
						unreadMessageCount: 0 // 当前正在聊天，未读数应为0
					};
					
					// 更新列表
					this.$set(this.dataList, currentIndex, updatedSession);
					
					// 重新排序：按最新消息时间降序，当前会话应排到顶部
					this.dataList.sort((a, b) => {
						const timeA = a.latestMessage?.sentTime || 0;
						const timeB = b.latestMessage?.sentTime || 0;
						return new Date(timeB) - new Date(timeA);
					});
					
					this.dataList = [...this.dataList]; // 确保响应式更新
					this.persistConversationList();
				}
				
				// 同时更新聊天窗口的消息
				if (this.$refs.SpiderWindowMessagebox && this.$refs.SpiderWindowMessagebox.$refs.SpiderWindowMymessage) {
					console.log('更新聊天窗口的消息:', message);
					console.log('消息 content:', message.content);
					console.log('消息 messageType:', message.messageType);
					console.log('消息 sentTime:', message.sentTime);
					
					// 获取对方信息
					const targetSession = this.dataList.find(item => item.targetId === this.$store.state.rongyun.targetId);
					
					// 处理消息，添加必要的字段
					const processedMessage = {
						...message,
						messageDirection: messageDirection,
						avatar: messageDirection === 2 ? (targetSession?.infoData?.avatar || '') : '',
						senderUser: messageDirection === 2 ? (targetSession?.infoData?.nickName || '') : ''
					};
					console.log('处理后的消息:', processedMessage);
					this.$refs.SpiderWindowMessagebox.$refs.SpiderWindowMymessage.addSendMsg(processedMessage);
				}
			},
			// 检查是否是今天
			isToday(date) {
				if (!date) return false;
				const today = new Date();
				const targetDate = new Date(date);
				// 重置时间部分，只比较日期
				today.setHours(0, 0, 0, 0);
				targetDate.setHours(0, 0, 0, 0);
				return today.getTime() === targetDate.getTime();
			},
			// 检查是否是昨天
			isYesterday(date) {
				if (!date) return false;
				const yesterday = new Date();
				yesterday.setDate(yesterday.getDate() - 1);
				yesterday.setHours(0, 0, 0, 0);
				const targetDate = new Date(date);
				targetDate.setHours(0, 0, 0, 0);
				return yesterday.getTime() === targetDate.getTime();
			},
			// 检查是否是前天
			isDayBeforeYesterday(date) {
				if (!date) return false;
				const dayBeforeYesterday = new Date();
				dayBeforeYesterday.setDate(dayBeforeYesterday.getDate() - 2);
				dayBeforeYesterday.setHours(0, 0, 0, 0);
				const targetDate = new Date(date);
				targetDate.setHours(0, 0, 0, 0);
				return dayBeforeYesterday.getTime() === targetDate.getTime();
			},
		},
		beforeDestroy() {
			// 清除定时器
			if (this.messageInterval) {
				clearInterval(this.messageInterval);
			}
			if (this.updateTimer) {
				clearTimeout(this.updateTimer);
			}
		}

	};
</script>

<style scoped>
	.index {
		display: flex;
		flex: 1;
	}

	.chat-list {
		width: 253px;
		user-select: none;
		cursor: pointer;
		height: 100%;
		background: #ffffff;
	}

	.chat-list .chat-list-user {
		height: calc(100% - 130px);
		/* height: 473px; */
		overflow-x: hidden;
		overflow-y: auto;
	}

	.nav-title {
		height: 60px;
		line-height: 60px;
		font-size: 18px;
		letter-spacing: 2px;
		padding: 10px;
		display: flex;
		align-items: center;
		background: #f5f7fa;
		box-sizing: border-box;
		border-bottom: 1px solid #dcdfe6;
	}

	.chat-list-user .user-info {
		height: 67px;
		display: flex;
		align-items: center;
		padding: 0 12px;
		border: 1px solid #dcdfe6;
		box-sizing: border-box;
	}

	.user-info:hover {
		background: #f5f7fa;
	}

	.active-background {
		height: 67px;
		display: flex;
		align-items: center;
		background: #f5f7fa;
		padding: 0 12px;
		border: 1px solid #dcdfe6;
		box-sizing: border-box;
	}

	.chat-list-user .user-icon {
		position: relative;
		flex-shrink: 0;
	}

	.chat-list-user .user-icon img {
		width: 42px;
		height: 42px;
		border-radius: 50%;
		margin-right: 8px;
	}

	.user-icon .badge {
		position: absolute;
		width: 16px;
		height: 16px;
		line-height: 16px;
		font-size: 12px;
		color: #ffffff;
		text-align: center;
		background: #ff6632;
		border-radius: 50%;
		top: 0;
		right: 2px;
	}

	.user-icon .badge2 {
		position: absolute;
		width: 21px;
		height: 16px;
		line-height: 16px;
		font-size: 12px;
		color: #ffffff;
		text-align: center;
		background: #ff6632;
		border-radius: 8px;
		top: 0;
		right: 2px;
	}

	.chat-list-user .user-right {
		flex: 1;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
	}

	.user-right div {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		margin-bottom: 8px;
	}

	.user-right div p {
		font-size: 14px;
		color: #313233;
	}

	.user-right div p:nth-child(2) {
		font-size: 12px;
		color: #abaeb3;
	}

	.default {
		min-width: 506px;
		display: flex;
		flex: 1;
		align-items: center;
		justify-content: space-around;
		background: #f5f7fa;
		border-left: 1px solid #dcdfe6;
	}

	.default img {
		width: 100px;
		height: 100px;
	}

	.msg-box {
		flex: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.user_name {
		flex: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
</style>